import { getState } from '~src/state';
import { displayBackgroundManager } from '~src/sidebar/index';

export const addBackgroundTagToCache = (backgroundItemId, tagsId) => {
  const currentTag = getState('sidebarCurrentBackgroundsTag', 'NO_TAG');
  const backgroundItem = window.editorConfig.sidebarBackgrounds[
    currentTag
  ].items.find((item) => item.objectId === backgroundItemId);

  if (!backgroundItem) {
    console.error('Background item not found:', backgroundItemId);
    return;
  }

  if (tagsId) {
    tagsId.forEach((id) => {
      const tagItem = window.editorConfig.sidebarTags.items.find(
        (item) => item.objectId === id
      );
      backgroundItem.tags.push(tagItem);
    });
  }

  displayBackgroundManager(backgroundItemId);
};
